var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMergeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10606_106374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4819 1H8.53012C6.53301 1 4.61769 1.79335 3.20552 3.20552C1.79335 4.61769 1 6.53301 1 8.53012L1 21.4819C1 23.479 1.79335 25.3944 3.20552 26.8065C4.61769 28.2187 6.53301 29.012 8.53012 29.012H21.4819C23.479 29.012 25.3944 28.2187 26.8065 26.8065C28.2187 25.3944 29.012 23.479 29.012 21.4819V8.53012C29.012 6.53301 28.2187 4.61769 26.8065 3.20552C25.3944 1.79335 23.479 1 21.4819 1ZM3.45783 20.1084V9.3494H26.5452V20.1084H3.45783ZM26.5392 8.2741H15.759V3.45482H21.4819C22.7823 3.45559 24.0326 3.95636 24.974 4.85345C25.9154 5.75054 26.4758 6.97526 26.5392 8.2741ZM8.53012 3.45783H14.253V8.27711H3.46386C3.5266 6.97646 4.08803 5.74999 5.03151 4.85251C5.97498 3.95503 7.22796 3.45554 8.53012 3.45783ZM3.45783 21.4819V21.1807H14.2319V26.5422H8.53012C7.86481 26.543 7.20586 26.4127 6.59089 26.1588C5.97591 25.905 5.41697 25.5324 4.94596 25.0626C4.47496 24.5927 4.10112 24.0346 3.84578 23.4202C3.59045 22.8059 3.45862 22.1472 3.45783 21.4819ZM21.4819 26.5452H15.759V21.1807H26.5452V21.4819C26.5444 22.8245 26.0107 24.1119 25.0613 25.0613C24.1119 26.0107 22.8245 26.5444 21.4819 26.5452Z",
    fill: "#2D2F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1328 12.332H16.922L18.7593 14.1664H11.7865L13.6238 12.332H11.413L8.81055 14.9344L11.413 17.5369H13.6238L11.7865 15.6995H18.7593L16.922 17.5369H19.1328L21.7352 14.9344L19.1328 12.332Z",
    fill: "#2D2F37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10606_106374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMergeLine);
export default __webpack_public_path__ + "static/media/ic_merge_line.dfcb19dbc0b713e391f542b57b4cfcd3.svg";
export { ForwardRef as ReactComponent };